<template>
    <div id="audit-logs" class="setting-page-content-wrapper audit-logs">
        <div class="page-header">
            <div class="title">{{ $t("auditLogs.auditLogsTitle") }}</div>
            <div class="subtitle">
                {{ $t("auditLogs.auditLogsSub") }}
            </div>
        </div>
        <section>
            <ve-table
                :columns="getColumns()"
                :table-data="activities"
                :row-style-option="rowStyleOption"
                :border-x="true"
                :border-y="true"
                :expand-option="expandOption"
                row-key-field-name="_id"
                id="audit-logs-table"
                :fixed-header="true"
            />
            <div class="actions">
                <SupsisButton primary @click="loadNextPage" small :disabled="loading" v-if="activities.length"
                    >Load More...
                </SupsisButton>
            </div>
        </section>
    </div>
</template>
<script>
import Vue from "vue";
import { ACTIVITY_API } from "../../../../../api/activity";
import moment from "moment";
import { PrismEditor } from "vue-prism-editor";
import "vue-prism-editor/dist/prismeditor.min.css"; // import the styles somewhere

// import highlighting library (you can use any library you want just return html string)
import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-json";
import "prismjs/themes/prism-tomorrow.css";

// import language config
import SupsisButton from "../../components/SupsisButton.vue";
import { mapActions, mapState } from "vuex";
import { VeLocale } from "vue-easytable";
import enUS from "vue-easytable/libs/locale/lang/en-US.js";
import { VePagination } from "vue-easytable";

Vue.use(VePagination);
VeLocale.use(enUS);
export default Vue.extend({
    name: "AuditLogs",
    components: { SupsisButton, PrismEditor },
    data(x) {
        return {
            loadingInstance: null,
            rowStyleOption: {
                stripe: true,
            },

            filter: {
                actorIds: [],
                startDate: null,
                endDate: null,
                activityTypes: [],
            },
            loading: false,
            activities: [],
            totalCount: 0,
            cursor: {
                page: 1,
                perPage: 50,
            },
            expandOption: {
                render: ({ row, column, rowIndex }, h) => {
                    return h(PrismEditor, {
                        props: {
                            value: JSON.stringify(row.payload || {}, null, 2),
                            class: "my-editor",
                            lineNumbers: true,
                            readOnly: true,
                            highlight: (code) => highlight(code, languages.json),
                        },
                    });
                },
            },
            activityTypes: [
                {
                    value: "chat-assign",
                    label: "Chat assign , forward or join ",
                },
                {
                    value: "ticket-assign",
                    label: "Ticket assigment",
                },
                {
                    value: "task-assign",
                    label: "Task assigment",
                },
                {
                    value: "chat-close-own",
                    label: "Chat close events",
                },
                {
                    value: "tag-actions-to-visitor",
                    label: "Tags added or removed from a contact",
                },
                {
                    value: "create-ticket",
                    label: "Ticket creation",
                },
                {
                    value: "note-actions-to-visitor",
                    label: "Notes added or removed from a contact",
                },
                {
                    value: "visitor-profile-updates",
                    label: "Visitor profile updates",
                },

                {
                    value: "chat-start",
                    label: "Chat start actions",
                },
                {
                    value: "user-crud",
                    label: "User events",
                },
                {
                    value: "department-crud",
                    label: "Department events",
                },
                {
                    value: "settings-crud",
                    label: "Settings events",
                },
                {
                    value: "integration-channel-crud",
                    label: "Integration channel events",
                },
                {
                    value: "login-form-crud",
                    label: "Login form events",
                },
                {
                    value: "banned-word-crud",
                    label: "Banned word events",
                },
                {
                    value: "email-account-crud",
                    label: "Email account events",
                },
                {
                    value: "prepared-content-crud",
                    label: "Prepared content events",
                },
                {
                    value: "role-crud",
                    label: "Role events",
                },
                {
                    value: "tag-crud",
                    label: "Tag events",
                },
                {
                    value: "welcome-message-crud",
                    label: "Welcome message events",
                },
                {
                    value: "webhook-crud",
                    label: "Webhook events",
                },
                {
                    value: "billing-events",
                    label: "Billing events",
                },
                {
                    value: "task-workflow-crud",
                    label: "Task workflow events",
                },
                {
                    value: "task-crud",
                    label: "Task events",
                },
                {
                    value: "system-status",
                    label: "Online/Offline events",
                },
                {
                    value: "chatbot-story-crud",
                    label: "Chatbot story events",
                },
                {
                    value: "chatbot-user-segment-crud",
                    label: "User segment events",
                },
                {
                    value: "chatbot-credit-low",
                    label: "Chatbot credit events",
                },
                {
                    value: "whatsapp-credit-low",
                    label: "Whatsapp credit events",
                },
                {
                    value: "whatsapp-customer-group-crud",
                    label: "Whatsapp customer group events",
                },
                {
                    value: "whatsapp-broadcast-message-crud",
                    label: "Whatsapp broadcast events",
                },
                {
                    value: "whatsapp-template-message-crud",
                    label: "Whatsapp template events",
                },
            ],
        };
    },
    methods: {
        ...mapActions({
            getUsers: "user/getUsers",
        }),
        getColumns() {
            console.log("getColumns", this.users);
            return [
                {
                    field: "",
                    key: "a",
                    type: "expand",
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "createdAt",
                    key: "createdAt",
                    title: "Date and Time",
                    align: "left",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return <span>{moment(row.createdAt).format("YYYY-MM-DD HH:mm:ss")}</span>;
                    },
                },
                {
                    field: "actor",
                    key: "actor",
                    title: "Actor",
                    align: "left",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return <span>{this.getActorName(row)}</span>;
                    },
                    filter: {
                        filterList: [
                            {
                                value: "system",
                                label: "System (Supsis)",
                                selected: this.filter.actorIds.includes("system"),
                            },
                            {
                                value: "chatbot",
                                label: "Chatbot",
                                selected: this.filter.actorIds.includes("chatbot"),
                            },
                            {
                                value: "api",
                                label: "API",
                                selected: this.filter.actorIds.includes("api"),
                            },
                            {
                                value: "visitor",
                                label: "Any Visitor",
                                selected: this.filter.actorIds.includes("visitor"),
                            },
                            {
                                value: "agent",
                                label: "Any Agent",
                                selected: this.filter.actorIds.includes("agent"),
                            },
                        ].concat(
                            this.users.map((user) => {
                                return {
                                    value: user._id,
                                    label: user.name,
                                    selected: this.filter.actorIds.includes(user._id),
                                };
                            })
                        ),
                        isMultiple: true,
                        // filter confirm hook
                        filterConfirm: (filterList) => {
                            this.filter.actorIds = filterList.filter((x) => x.selected).map((x) => x.value);
                        },
                        // filter reset hook
                        filterReset: (filterList) => {
                            this.filter.actorIds = [];
                        },
                        // max height
                        maxHeight: 400,
                        width: 300,
                    },
                },
                {
                    field: "ipAddress",
                    key: "ipAddress",
                    title: "IP Address",
                    align: "left",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        console.log("ipAddress.renderBodyCell", { row, column, rowIndex, h });
                        return (
                            <span class="text-bold" style="color:#1890ff;">
                                {row.ipAddress || "-"}
                            </span>
                        );
                    },
                },
                {
                    field: "type",
                    key: "type",
                    title: "Event",
                    align: "left",
                    filter: {
                        filterList: this.activityTypes.map((activity) => {
                            return {
                                value: activity.value,
                                label: activity.label,
                                selected: this.filter.activityTypes.includes(activity.value),
                            };
                        }),
                        isMultiple: true,
                        // filter confirm hook
                        filterConfirm: (filterList) => {
                            this.filter.activityTypes = filterList.filter((x) => x.selected).map((x) => x.value);
                        },
                        // filter reset hook
                        filterReset: (filterList) => {
                            this.filter.activityTypes = [];
                        },
                        // max height
                        maxHeight: 400,
                        width: 300,
                    },
                },
            ];
        },
        loadNextPage() {
            this.cursor.page++;
            this.fetchActivities(true);
        },
        pageNumberChange(pageIndex) {
            this.cursor.page = pageIndex;
        },
        // page size change
        pageSizeChange(pageSize) {
            this.cursor.page = 1;
            this.cursor.perPage = pageSize;
        },
        updateFilters(filter) {
            this.filter = filter;
        },
        fetchActivities(concatMode = false) {
            this.loading = true;
            this.loadingInstance.show();
            ACTIVITY_API.ACTIVITY.list(this.cursor, this.filter)
                .then((response) => {
                    const { items } = response.data;
                    if (concatMode) {
                        this.activities = this.activities.concat(items);
                    } else {
                        this.activities = items;
                    }
                })
                .finally(() => {
                    this.loading = false;
                    this.loadingInstance.close();
                });
        },

        getActorName(activity) {
            if (activity.actor === "user") {
                return this.$_.get(activity, "actorUser.name");
            } else if (activity.actor === "visitor") {
                return this.$_.get(activity, "refVisitor.fullname");
            } else if (activity.actor === "chatbot") {
                return "Chatbot";
            } else if (activity.actor === "system") {
                return "System";
            }
        },
    },
    computed: {
        ...mapState({
            users: (state) => state.user.users.data,
        }),
    },
    mounted() {
        this.loadingInstance = this.$veLoading({
            target: document.querySelector("#audit-logs-table"),
            name: "wave",
        });
        this.fetchActivities();
    },
    watch: {
        filter: {
            deep: true,
            handler() {
                this.cursor.page = 1;
                this.fetchActivities();
            },
        },
        loading: {
            handler() {},
        },
    },
});
</script>

<style lang="scss">
#audit-logs {
    .actions {
        display: flex;
        justify-content: center;
        margin-top: 20px;
    }
}
</style>
